import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { fileGroupOptions, fileStatusOptions, fileTypeOptions, yesNoOptions } from '../../../utils/mics';
import { Dropdown } from 'primereact/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';
import { MultiSelect } from 'primereact/multiselect';
import { useLocation } from 'react-router';

const FileFilterForm = ({ handleSearch, handleReset, onFormValuesChange }) => {

    const dispatch = useDispatch();
    const { state } = useLocation();

    const [fileId, setFileId] = useState(state?.filterByFileId || null);
    
    useEffect(() => {
          dispatch(appActions.INTFILE_SET_FILTERS_REQUEST({fileId}));
    }, [fileId]); // Only trigger when date_from changes

    const filters = useSelector((state) => state.intFile.filters);
    
    const formik = useFormik({
        initialValues: {
            id: fileId ||filters?.id || '',
            storeId:  filters?.storeId || '',
            fileName: filters?.fileName || '',
            fileGroup: filters?.fileGroup || null,
            date_from: filters?.date_from || moment().subtract(30, 'days').toDate(),
            date_till: filters?.date_till || new Date(),
            status: filters?.status || null,
            fileType: filters?.fileType || null
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                date_from: values.date_from ? moment(values.date_from).format('YYYY-MM-DD') : '',
                date_till: values.date_till ? moment(values.date_till).format('YYYY-MM-DD') : '',
                fileGroup: values?.fileGroup ? values?.fileGroup?.join(",") : values?.fileGroup,
            };

            dispatch(appActions.INTFILE_SET_FILTERS_REQUEST(values));

            handleSearch(data);
            // Optionally, call onFormValuesChange here as well
            if (onFormValuesChange) {
                onFormValuesChange(data);
            }
        },
       
    });

    const handleClear = () => {
        dispatch(appActions.INTFILE_SET_FILTERS_REQUEST({}));
        formik.resetForm();
        onFormValuesChange(null);
        handleReset();
    };

    const handleChange = (e) => {
        formik.handleChange(e);
        if (onFormValuesChange) {
            const updatedValues = { ...formik.values, [e.target.name]: e.target.value };
            const data = {
                ...updatedValues,
                date_from: updatedValues.date_from ? moment(updatedValues.date_from).format('YYYY-MM-DD') : '',
                date_till: updatedValues.date_till ? moment(updatedValues.date_till).format('YYYY-MM-DD') : '',
            };
            onFormValuesChange(data);
        }
    }

    const isDateTillUpdated = useRef(false); // Track if update is needed

    useEffect(() => {
        if (
            formik.values.date_from &&
            (!formik.values.date_till || new Date(formik.values.date_till) < new Date(formik.values.date_from))
        ) {
            if (!isDateTillUpdated.current) { // Prevent infinite loop
                formik.setFieldValue("date_till", formik.values.date_from);
                isDateTillUpdated.current = true; // Mark as updated
            }
        } else {
            isDateTillUpdated.current = false; // Reset when update is not needed
        }
    }, [formik, formik.values.date_from]); // Only trigger when date_from changes

    const renderFormArea = () => {
        return (
            <>
                <div className="p-fluid formgrid grid w-full">
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">File Id</label>
                        <InputText id="id" name="id" type="text" value={formik.values.id} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">File Name</label>
                        <InputText id="fileName" name="fileName" type="text" value={formik.values.fileName} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">Store ID</label>
                        <InputText id="storeId" name="storeId" type="storeId" value={formik.values.storeId} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">File Group</label>
                        <MultiSelect showClear filter value={formik.values.fileGroup}  onChange={handleChange}  options={fileGroupOptions} id="fileGroup" name="fileGroup" optionLabel="name" optionValue='name'  placeholder="Select File Group" maxSelectedLabels={3}/>
                        {/* <Dropdown filter showClear value={formik.values.fileGroup} onChange={handleChange} options={fileGroupOptions} id="fileGroup" name="fileGroup" optionLabel="name" optionValue='name' /> */}
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">File Type</label>
                         <Dropdown filter  showClear  value={formik.values.fileType} onChange={handleChange} options={fileTypeOptions}  id="fileType" name="fileType" optionLabel="name" optionValue='code' />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">Received</label>
                         <Dropdown filter showClear  value={formik.values.received} onChange={handleChange} options={yesNoOptions}  id="received" name="received" optionLabel="name" optionValue='code' />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">Converted</label>
                         <Dropdown filter showClear  value={formik.values.converted} onChange={handleChange} options={yesNoOptions}  id="converted" name="converted" optionLabel="name" optionValue='code' />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">Uploaded</label>
                         <Dropdown filter showClear  value={formik.values.uploaded} onChange={handleChange} options={yesNoOptions}  id="uploaded" name="uploaded" optionLabel="name" optionValue='code' />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">Error</label>
                         <Dropdown filter showClear  value={formik.values.error} onChange={handleChange} options={yesNoOptions}  id="error" name="error" optionLabel="name" optionValue='code' />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">Processed</label>
                         <Dropdown filter showClear value={formik.values.processed} onChange={handleChange} options={yesNoOptions} id="processed" name="processed" optionLabel="name" optionValue='code' />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="status">Status</label>
                        <Dropdown filter showClear value={formik.values.status} onChange={handleChange} options={fileStatusOptions}  id="status" name="status" optionLabel="name" optionValue='code' placeholder="Select status" />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date From</label>
                        <Calendar id="date_from" name="date_from" value={formik.values.date_from} onChange={handleChange} dateFormat="dd-mm-yy" showIcon maxDate={new Date()}/>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_till">Date Till</label>
                        <Calendar id="date_till" name="date_till" value={formik.values.date_till} onChange={handleChange} dateFormat="dd-mm-yy" showIcon minDate={formik.values.date_from}/>
                    </div>
                </div>
                <div className="grid px-2 py-4 flex-row-reverse gap-10">
                    <Button type="submit" icon="pi pi-search" label="Search" severity="success" outlined className="p-button-success mr-2 tp" data-pr-tooltip="Search"/>
                    <Button type="button" icon="pi pi-filter-slash" className='tp' data-pr-tooltip="Reset Filter" label="Reset Filter" severity="secondary" outlined onClick={handleClear} />
                </div>
            </>
        );
    };

    return <form onSubmit={formik.handleSubmit}>{renderFormArea()}</form>;
};

export default FileFilterForm;
